import Vue from 'vue'
import http from '@/services/http.service'

// 各コンポーネントからアクセスするときの名前登録（テンプレ）
Vue.mixin({
  beforeCreate() {
    const options = this.$options
    if (options.maker) this.$maker = options.maker
    else if (options.parent && options.parent.$maker)
      this.$maker = options.parent.$maker
  },
})

export default {
  /**
   * キーワードで取得
   */
  async getByKeyWord(keyword) {
    try {
      const response = await http.get(`/makers?keyword=${keyword}`)
      return response.data
    } catch (error) {
      if (error.response.status === 404) {
        return undefined
      } else {
        throw error
      }
    }
  },
  /**
   * コードで取得
   */
  async getByCode(codes) {
    const response = await http.get(`/makers?codes=${codes.join(',')}`)
    return response.data
  },
}
